import Button from "@material-ui/core/Button";
import blueGrey from "@material-ui/core/colors/blueGrey";
import { modalStressTextColor, modalTextColor } from "../../lib/Color";
import { FilterRarityType } from "../hooks/AssetSettingModalType";

type Props = {
    rarity: FilterRarityType;
    selectedRarity: FilterRarityType;
    onSelectStateFilterRarity: (selectedRarity: FilterRarityType) => void,
}

const AssetRarityButton = ({ rarity, selectedRarity, onSelectStateFilterRarity }: Props) => {
    const isSelected = rarity === selectedRarity
    const buttonStyle = isSelected ? {
        borderColor: modalStressTextColor,
        borderWidth: "2px",
        color: modalStressTextColor,
        margin: "5px"
    } : {
        borderColor: modalTextColor,
        borderWidth: "2px",
        color: modalTextColor,
        margin: "5px"
    }
    const onClick = () => {
        onSelectStateFilterRarity(isSelected ? "None" : rarity)
    }
    return (
        <Button variant="outlined" style={buttonStyle} onClick={onClick}>
            {rarity}
        </Button>
    );
}

export default AssetRarityButton;